import { render, staticRenderFns } from "./CustomerPricesExportPopup.vue?vue&type=template&id=71865947&"
import script from "./CustomerPricesExportPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerPricesExportPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports